import { PastEvent, PastEventsProductionState } from '@img-arena/consoles-api-streaming'
import { Button, ListItemText, useTheme } from '@mui/material'
import { CreateProductionReportForm } from '@/components/forms/CreateProductionReportForm'
import { useUnmountingDelay } from '@/hooks/useUnmountingDelay'

import { useActionMenuContext } from '../context/ActionMenuContext'
import { MenuItemLike } from '../index.types'

export const ISSUES_LABEL = 'ISSUES' as const

type Props = MenuItemLike & {
  onAfterSubmit?: () => void
}

export const ActionReportIssues = <Data extends PastEvent>({
  overrideText,
  onAfterSubmit
}: Props) => {
  const theme = useTheme()
  const { close, open, isMounted, isOpen } = useUnmountingDelay()
  const { row, closeMenu } = useActionMenuContext<Data>()

  const handleOnOpen = () => {
    open()
  }

  const hasIssues = row.lastProductionReportState === PastEventsProductionState.FAILED

  const { backgroundColor: buttonBg, hoverBackgroundColor: buttonHoverBg } =
    theme.palette.productionReport.actionButton

  return (
    <>
      <Button
        sx={{
          backgroundColor: hasIssues ? theme.palette.error.main : buttonBg,
          '&:hover': {
            backgroundColor: hasIssues ? undefined : buttonHoverBg
          },
          mr: 1
        }}
        variant="contained"
        onClick={handleOnOpen}
      >
        <ListItemText>{overrideText || ISSUES_LABEL}</ListItemText>
      </Button>

      {isMounted && (
        <CreateProductionReportForm
          open={isOpen}
          eventId={row.eventId}
          hasReportAvailable={hasIssues}
          onSubmit={onAfterSubmit}
          onClose={() => {
            close()
            closeMenu?.()
          }}
        />
      )}
    </>
  )
}
